<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.qualityItem.new')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityItem">
              <span>{{$t('tlt.qualityItem.list')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
             <router-link :to="{path:'/prd/qualityItemDetails', query:{id: qualityItemStatus.id}}">
             <span>{{$t('tlt.qualityItem.details')}}</span>
            </router-link>
          </li>
           <li class="breadcrumb-item">
             <router-link to="/prd/qualityItemDetails/edit">
              <span>{{$t('tlt.qualityItemDetails.edit')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('qualityItemDetails')"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <!-- <button class="btn btn-primary" type="button" v-on:click="validateForm"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>Save</span></button> -->
          <button class="btn btn-primary" type="button" v-on:click="Save('qualityItemDetails')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>

    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemCode')}}:
                </label>
                <input
                  id="itemCode"
                  v-validate="'required'"
                  name="itemCode"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('itemCode') }"
                  v-model="itemCode"
                  type="text"
                  disabled="disabled"
                />
                <span v-show="errors.has('itemCode')" class="lbl-obg">{{ errors.first('itemCode') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemName')}}:
                </label>
                <input
                  id="itemName"
                  v-validate="'required'"
                  name="itemName"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('itemName') }"
                  v-model="itemName"
                  type="text"
                  disabled="disabled"
                />
                <span v-show="errors.has('itemName')" class="lbl-obg">{{ errors.first('itemName') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemCraftType')}}:
                </label>
                <select class="form-control" type="text" v-model="craftType" disabled="disabled">
                  <option value>{{ $t("lbl.basic.select.one") }}</option>
                  <option value="p">{{$t("lbl.qualityItem.pelletizing")}}</option>
                  <option value="s">{{$t("lbl.qualityItem.smelt")}}</option>
                </select>
                <span
                  v-show="errors.has('craftType')"
                  class="lbl-obg"
                >{{ errors.first('craftType') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemCheckType')}}:
                </label>
                <select class="form-control" type="text" v-model="checkType" disabled="disabled">
                  <option value>{{ $t("lbl.basic.select.one") }}</option>
                  <option value="material">{{$t("lbl.qualityItem.material")}}</option>
                  <option value="process">{{$t("lbl.qualityItem.process")}}</option>
                  <option value="production">{{$t("lbl.qualityItem.production")}}</option>
                </select>
                <span
                  v-show="errors.has('checkType')"
                  class="lbl-obg"
                >{{ errors.first('checkType') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.parameterCode')}}:
                </label>
                <!--可以改为dimsearch-->
                <dimsearch
                  validate="required"
                  name="parameterCode"
                  v-model="parameterId"
                  :entity="parameters"
                  bindId="parameter"
                  bindProp="code"
                  submitProp="id"
                ></dimsearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.parameterName')}}:
                </label>
                <!--可以改为dimsearch-->
                <dimsearch
                  validate="required"
                  name="parameterName"
                  v-model="parameterId"
                  :entity="parameters"
                  bindId="parameter"
                  bindProp="name"
                  submitProp="id"
                ></dimsearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.parameterUnit')}}:
                </label>
                <!--可以改为dimsearch-->
                <dimsearch
                  validate="required"
                  name="parameterUnit"
                  v-model="parameterId"
                  :entity="parameters"
                  bindId="parameter"
                  bindProp="unit"
                  submitProp="id"
                ></dimsearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.measureUp')}}:
                </label>
                <dimsearch
                  validate="required"
                  name="parameterUnit"
                  v-model="parameterId"
                  :entity="parameters"
                  bindId="parameter"
                  bindProp="lowLimit"
                  submitProp="id"
                ></dimsearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.measureDown')}}:
                </label>
                <dimsearch
                  validate="required"
                  name="parameterUnit"
                  v-model="parameterId"
                  :entity="parameters"
                  bindId="parameter"
                  bindProp="upLimit"
                  submitProp="id"
                ></dimsearch>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import router from "@/router/index";
//import MmfTable from "@/components/MmfTable";
import dimsearch from "@/components/MMFDimSearch";
import { fields } from "@/model/prd/qualityMgt/qualityItemConfig/QualityItemDetails";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityItemDetails/getField",
  mutationType: "qualityItemDetails/updateField"
});

export default {
  name: "qualityItemEdit",
  data() {
    return {
      parameters: []
    };
  },
  components: { dimsearch },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapState({
      rows: state => state.qualityItemDetails.rows,

      entity: state => state.qualityItemDetails.entity,

      qualityItemStatus : state =>state.qualityItemDetails.qualityItemStatus
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFClearFilter"]),

    ...mapActions("qualityItemDetails", ["Save"]),

    
      
  },
  created() {
    this.$store
      .dispatch(
        "api/get",
        {
          url:
            this.$store.state.qualityItem.baseModuleUrl +
            "/qualitySpecification/findAll"
        },
        {
          root: true
        }
      )
      .then(data => {
        this.parameters = data;
      });
  }
};
</script>
